/* ============================================================
   MICROLUX 10.0 — Home interactions
   Comparison slider, layering modes, catalog finder, finance tool
   ============================================================ */

(function () {
  'use strict';

  var $ = function (selector, context) {
    return (context || document).querySelector(selector);
  };

  var $$ = function (selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  };

  function emitEvent(name, detail) {
    var payload = detail || {};
    var analyticsPayload = { event: 'microlux_' + name };
    Object.keys(payload).forEach(function (key) { analyticsPayload[key] = payload[key]; });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(analyticsPayload);
    document.dispatchEvent(new CustomEvent('microlux:' + name, { detail: payload }));
  }

  function initTrackedActions() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ml-event]');
      if (!trigger) return;
      emitEvent(trigger.dataset.mlEvent, {
        location: trigger.dataset.mlLocation || '',
        destination: trigger.getAttribute('href') || ''
      });
    });

    $$('[data-ml-contact-form] form').forEach(function (form) {
      form.addEventListener('submit', function () {
        emitEvent('project_form_submit', { location: 'homepage' });
      });
    });
  }

  function initReveals() {
    var items = $$('.ml-reveal');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (item, index) {
      item.style.transitionDelay = Math.min(index % 4, 3) * 45 + 'ms';
      observer.observe(item);
    });
  }

  function initComparisonSliders() {
    $$('[data-ml-comparison]').forEach(function (comparison) {
      var range = $('[data-ml-comparison-range]', comparison);
      if (!range) return;

      function update() {
        var value = Number(range.value);
        comparison.style.setProperty('--ml-split', value + '%');
        range.setAttribute('aria-valuetext', value + ' percent display mode');
      }

      range.addEventListener('input', update);
      range.addEventListener('change', update);
      update();
    });
  }

  function initLayering() {
    var presets = {
      sports: ['College football', 'Conference game', 'Premier League', 'Live leaderboard', 'Fantasy matchup', 'RedZone'],
      family: ['Co-op adventure', 'Player two', 'Family video chat', 'Music queue', 'Photo stream', 'Game guide'],
      work: ['Master schedule', 'Financial model', 'Field cameras', 'Team meeting', 'Project dashboard', 'Email + chat']
    };

    $$('[data-ml-layering]').forEach(function (root) {
      var buttons = $$('[data-ml-layer-mode]', root);
      var feeds = $$('[data-ml-feed]', root);
      var copies = $$('[data-ml-mode-copy]', root);

      function selectMode(mode) {
        buttons.forEach(function (button) {
          button.setAttribute('aria-pressed', String(button.dataset.mlLayerMode === mode));
        });

        copies.forEach(function (copy) {
          copy.hidden = copy.dataset.mlModeCopy !== mode;
        });

        (presets[mode] || presets.sports).forEach(function (label, index) {
          if (feeds[index]) feeds[index].textContent = label;
        });

        root.dataset.activeMode = mode;
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          selectMode(button.dataset.mlLayerMode);
        });
      });
    });
  }

  var FALLBACK_CATALOG = {
    lifestyle: {
      label: 'Lifestyle',
      code: 'LS',
      aspect: '16:9',
      sizes: [81, 108, 136, 163],
      sizeMeta: {
        81: { grid: '3×3 cabinets', ratio: '16:9' },
        108: { grid: '4×4 cabinets', ratio: '16:9' },
        136: { grid: '5×5 cabinets', ratio: '16:9' },
        163: { grid: '6×6 cabinets', ratio: '16:9' }
      },
      url: '/pages/lifestyle',
      variants: []
    },
    cinemascape: {
      label: 'CinemaScape',
      code: 'CS',
      aspect: 'Exact ratio by cabinet array',
      sizes: [103, 129, 151, 178, 205],
      sizeMeta: {
        103: { grid: '4×3 cabinets', ratio: '2.37:1' },
        129: { grid: '5×4 cabinets', ratio: '2.22:1' },
        151: { grid: '6×4 cabinets', ratio: '2.67:1' },
        178: { grid: '7×5 cabinets', ratio: '2.49:1' },
        205: { grid: '8×6 cabinets', ratio: '2.37:1' }
      },
      url: '/pages/cinemascape',
      variants: []
    },
    ascent: {
      label: 'Ascent',
      code: 'AS',
      aspect: 'Coming Soon',
      sizes: [],
      url: '/pages/ascent',
      variants: []
    }
  };

  var TIERS = {
    prestige: { label: 'Prestige', pitch: '0.9375 mm (P0.9)', aliases: [0.9375, 0.93, 0.9], code: 'P093' },
    grand: { label: 'Grand', pitch: '1.25 mm (P1.2)', aliases: [1.25, 1.2], code: 'G125' },
    signature: { label: 'Signature', pitch: '1.50 mm (P1.5)', aliases: [1.5], code: 'S150' },
    studio: { label: 'Studio', pitch: '1.875 mm (P1.8)', aliases: [1.875, 1.8], code: 'T180' }
  };

  var FOUNDING_PRICE_DOLLARS = {};
  [
    'ML-LS-81-P093:11499', 'ML-LS-81-G125:8999', 'ML-LS-81-S150:8499', 'ML-LS-81-T180:7999',
    'ML-LS-108-P093:16499', 'ML-LS-108-G125:12299', 'ML-LS-108-S150:11399', 'ML-LS-108-T180:10599',
    'ML-LS-136-P093:22499', 'ML-LS-136-G125:17199', 'ML-LS-136-S150:15899', 'ML-LS-136-T180:14499',
    'ML-LS-163-P093:48499', 'ML-LS-163-G125:23499', 'ML-LS-163-S150:21299', 'ML-LS-163-T180:19499',
    'ML-CS-103-P093:13499', 'ML-CS-103-G125:10499', 'ML-CS-103-S150:9499', 'ML-CS-103-T180:8999',
    'ML-CS-129-P093:18999', 'ML-CS-129-G125:14399', 'ML-CS-129-S150:13399', 'ML-CS-129-T180:12299',
    'ML-CS-151-P093:24999', 'ML-CS-151-G125:18499', 'ML-CS-151-S150:16999', 'ML-CS-151-T180:15499',
    'ML-CS-178-P093:47999', 'ML-CS-178-G125:22999', 'ML-CS-178-S150:20999', 'ML-CS-178-T180:18999',
    'ML-CS-205-P093:57999', 'ML-CS-205-G125:29699', 'ML-CS-205-S150:27199', 'ML-CS-205-T180:24699'
  ].forEach(function (entry) {
    var parts = entry.split(':');
    FOUNDING_PRICE_DOLLARS[parts[0]] = Number(parts[1]);
  });

  function processorForSku(sku) {
    var value = String(sku || '');
    if (/-MX40P$/.test(value)) return 'MX40 Pro';
    if (/^ML-(LS|CS)-/.test(value)) return 'VX2000Pro';
    return 'MX40 Pro';
  }

  function baseConfigurationSku(sku) {
    return String(sku || '').replace(/-MX40P$/, '');
  }

  function vx2000EligibleSku(sku) {
    return /^ML-(LS|CS)-[0-9]+-(P093|G125|S150|T180)$/.test(baseConfigurationSku(sku));
  }

  function controllerKeyForModel(model) {
    if (model === 'VX2000Pro') return 'vx2000-pro';
    if (model === 'MX40 Pro') return 'mx40-pro';
    if (model === 'MX2000 Pro') return 'mx2000-pro';
    return 'mx40-pro';
  }

  function targetSkuForController(sku, controllerKey) {
    var base = baseConfigurationSku(sku);
    return controllerKey === 'mx40-pro' && vx2000EligibleSku(base) ? base + '-MX40P' : base;
  }

  function authoritativeVariant(productData, sku, controllerKey) {
    if (!productData || !Array.isArray(productData.variants)) return null;
    var targetSku = targetSkuForController(sku, controllerKey);
    return productData.variants.find(function (variant) {
      return String(variant.sku || '') === targetSku;
    }) || null;
  }

  function moneyCentsFromVariant(variant) {
    return variant && Number.isFinite(Number(variant.price)) ? Math.round(Number(variant.price)) : 0;
  }

  function skuSpecifications(sku) {
    var parts = String(sku || '').split('-');
    if (parts.length < 4 || parts[0] !== 'ML') return null;

    var seriesCode = parts[1];
    var size = parts[2];
    var pitchCode = parts[3];
    var lifestyleSizes = {
      81: { cols: 3, rows: 3, ratio: '16:9', metric: '1800 × 1012.5 mm', imperial: '70.9 × 39.9 in', actual: '81.3' },
      108: { cols: 4, rows: 4, ratio: '16:9', metric: '2400 × 1350 mm', imperial: '94.5 × 53.1 in', actual: '108.4' },
      136: { cols: 5, rows: 5, ratio: '16:9', metric: '3000 × 1687.5 mm', imperial: '118.1 × 66.4 in', actual: '135.5' },
      163: { cols: 6, rows: 6, ratio: '16:9', metric: '3600 × 2025 mm', imperial: '141.7 × 79.7 in', actual: '162.6' }
    };
    var cinemaSizes = {
      103: { cols: 4, rows: 3, ratio: '2.37:1', metric: '2400 × 1012.5 mm', imperial: '94.5 × 39.9 in', actual: '102.6' },
      129: { cols: 5, rows: 4, ratio: '2.22:1', metric: '3000 × 1350 mm', imperial: '118.1 × 53.1 in', actual: '129.5' },
      151: { cols: 6, rows: 4, ratio: '2.67:1', metric: '3600 × 1350 mm', imperial: '141.7 × 53.1 in', actual: '151.4' },
      178: { cols: 7, rows: 5, ratio: '2.49:1', metric: '4200 × 1687.5 mm', imperial: '165.4 × 66.4 in', actual: '178.2' },
      205: { cols: 8, rows: 6, ratio: '2.37:1', metric: '4800 × 2025 mm', imperial: '189.0 × 79.7 in', actual: '205.1' }
    };
    var pitches = {
      P093: {
        tier: 'Prestige', pitch: '0.9375 mm (P0.9)', pxW: 640, pxH: 360,
        story: 'Our finest indoor pitch, intended for the closest seats and the rooms where every pixel can be resolved. We recommend it only when the viewing distance earns the added precision.'
      },
      G125: {
        tier: 'Grand', pitch: '1.25 mm (P1.2)', pxW: 480, pxH: 270,
        story: 'The reference balance of close-viewing detail, scale and price. Grand is the all-rounder when the room needs refinement without paying for precision the seating cannot reveal.'
      },
      S150: {
        tier: 'Signature', pitch: '1.50 mm (P1.5)', pxW: 400, pxH: 225,
        story: 'Built to make a larger canvas attainable from normal great-room and cinema seating. Signature puts the budget into the part of the experience most people feel first: scale.'
      },
      T180: {
        tier: 'Studio', pitch: '1.875 mm (P1.8)', pxW: 320, pxH: 180,
        story: 'The strongest value when the room is large and the seats are farther back. Studio favors maximum physical presence over pixel density that distance would hide.'
      }
    };
    var isLifestyle = seriesCode === 'LS';
    var geometry = (isLifestyle ? lifestyleSizes : cinemaSizes)[size];
    var pitch = pitches[pitchCode];
    if (!geometry || !pitch) return null;

    var resolutionWidth = geometry.cols * pitch.pxW;
    var resolutionHeight = geometry.rows * pitch.pxH;
    var totalPixels = resolutionWidth * resolutionHeight;
    var series = isLifestyle ? 'Lifestyle' : 'CinemaScape';
    var seriesUse = isLifestyle
      ? 'a familiar 16:9 canvas for films, sports, gaming and everyday life'
      : 'an ultrawide canvas shaped around cinema and expansive multi-view layouts';
    return {
      sku: sku,
      series: series,
      size: size,
      tier: pitch.tier,
      pitch: pitch.pitch,
      tierStory: pitch.story,
      cols: geometry.cols,
      rows: geometry.rows,
      ratio: geometry.ratio,
      metric: geometry.metric,
      imperial: geometry.imperial,
      actual: geometry.actual,
      cabinetCount: geometry.cols * geometry.rows,
      cabinetResolution: pitch.pxW + ' × ' + pitch.pxH,
      resolution: resolutionWidth + ' × ' + resolutionHeight,
      totalPixels: totalPixels,
      totalPixelsLabel: new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(totalPixels / 1000000) + ' million',
      processor: processorForSku(sku),
      heading: series + ' ' + size + '″ · ' + pitch.tier,
      detailHeading: size + '-inch ' + series + ' ' + pitch.tier,
      eyebrow: series + ' · ' + pitch.tier + ' · ' + pitch.pitch,
      intro: 'A ' + geometry.ratio + ', ' + geometry.cols + '×' + geometry.rows + ' cabinet MicroLED wall—' + seriesUse + '.',
      heroCopy: isLifestyle
        ? 'A complete 16:9 Flip-Chip COB MicroLED wall configured for bright, mixed-use rooms—with the scale, pitch and processing stated before you call.'
        : 'A complete ultrawide Flip-Chip COB MicroLED wall configured around cinema and expansive multi-view layouts—with its exact physical proportions stated before you call.'
    };
  }

  function foundingPriceForSku(sku) {
    return FOUNDING_PRICE_DOLLARS[baseConfigurationSku(sku)] || 0;
  }

  function formattedCatalogPrice(dollars) {
    return dollars ? new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD', maximumFractionDigits: 0
    }).format(dollars) + ' USD' : '';
  }

  function formattedCatalogPriceFromCents(cents) {
    var numericCents = Number(cents);
    return Number.isFinite(numericCents) && numericCents > 0
      ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numericCents / 100) + ' USD'
      : '';
  }

  function catalogFromPage() {
    var data = { showPrices: false, foundingPricesEnabled: false, signatureOfferEnabled: false, series: {} };
    var script = $('#MicroLuxCatalogData');
    if (script) {
      try {
        data = JSON.parse(script.textContent);
      } catch (error) {
        // The finder continues with the published configuration matrix and no prices.
      }
    }

    var merged = {};
    Object.keys(FALLBACK_CATALOG).forEach(function (key) {
      var source = (data.series && data.series[key]) || {};
      merged[key] = Object.assign({}, FALLBACK_CATALOG[key], source);
      merged[key].sizes = FALLBACK_CATALOG[key].sizes.slice();
      merged[key].sizeMeta = Object.assign({}, FALLBACK_CATALOG[key].sizeMeta || {});
      merged[key].variants = Array.isArray(source.variants) ? source.variants : [];
    });
    return {
      showPrices: data.showPrices === true,
      foundingPricesEnabled: data.foundingPricesEnabled === true,
      signatureOfferEnabled: data.signatureOfferEnabled === true,
      series: merged
    };
  }

  var CATALOG_DATA = catalogFromPage();
  var CATALOG = CATALOG_DATA.series;

  function numericOption(value) {
    var match = String(value || '').replace(',', '.').match(/[0-9]+(?:\.[0-9]+)?/);
    return match ? Number(match[0]) : null;
  }

  function findVariant(seriesId, size, tierId) {
    var line = CATALOG[seriesId];
    var aliases = TIERS[tierId].aliases;
    var expectedSku = buildSku(seriesId, size, tierId);
    if (!line || !Array.isArray(line.variants)) return null;
    return line.variants.find(function (variant) {
      var options = variant.options || [];
      var optionPitch = numericOption(options[1]);
      if (baseConfigurationSku(variant.sku) === expectedSku) return true;
      return numericOption(options[0]) === Number(size) && aliases.some(function (pitch) {
        return optionPitch === pitch;
      });
    }) || null;
  }

  function valueFrom(form, name) {
    var checked = $('input[name="' + name + '"]:checked', form);
    return checked ? checked.value : '';
  }

  function sizeFor(seriesId, width) {
    var sizes = CATALOG[seriesId].sizes;
    if (!sizes.length) return null;
    var index = { narrow: 0, compact: 0, standard: 1, large: 2, estate: 3 }[width] || 0;
    if (seriesId === 'cinemascape' && width === 'estate') index = 4;
    return sizes[Math.min(index, sizes.length - 1)];
  }

  function buildSku(seriesId, size, tierId) {
    return 'ML-' + CATALOG[seriesId].code + '-' + size + '-' + TIERS[tierId].code;
  }

  function configObject(seriesId, size, tierId, reason) {
    var line = CATALOG[seriesId];
    var tier = TIERS[tierId];
    var variant = findVariant(seriesId, size, tierId);
    var configurationCode = variant && variant.sku ? variant.sku : buildSku(seriesId, size, tierId);
    var sizeMeta = line.sizeMeta && line.sizeMeta[size] ? line.sizeMeta[size] : null;
    var fallbackDollars = foundingPriceForSku(configurationCode);
    var signatureIntroSku = baseConfigurationSku(configurationCode) === 'ML-LS-108-S150';
    var launchSpecial = CATALOG_DATA.signatureOfferEnabled;
    var livePriceDollars = variant && Number(variant.priceCents) > 0 ? Number(variant.priceCents) / 100 : 0;
    var priceDollars = livePriceDollars || fallbackDollars;
    var compareAtDollars = !signatureIntroSku && variant && Number(variant.compareAtCents) > Number(variant.priceCents)
      ? Number(variant.compareAtCents) / 100
      : 0;
    var price = '';
    if (CATALOG_DATA.showPrices) price = variant && Number(variant.priceCents) > 0 && variant.priceFormatted
      ? variant.priceFormatted
      : formattedCatalogPrice(priceDollars);
    var processor = processorForSku(configurationCode);
    return {
      seriesId: seriesId,
      series: line.label,
      aspect: sizeMeta && sizeMeta.ratio ? sizeMeta.ratio : line.aspect,
      cabinetGrid: sizeMeta && sizeMeta.grid ? sizeMeta.grid : '',
      size: size,
      tierId: tierId,
      tier: tier.label,
      pitch: tier.pitch,
      sku: configurationCode,
      price: price,
      priceValue: priceDollars,
      compareAt: CATALOG_DATA.showPrices && compareAtDollars ? (variant && variant.compareAtFormatted ? variant.compareAtFormatted : formattedCatalogPrice(compareAtDollars)) : '',
      promoTerms: launchSpecial ? 'Grand Opening: enter code GRANDOPENING10 at checkout by September 30, 2026 for 10% off eligible screens. Optional professional installation is excluded. Displayed configuration prices are regular prices; no discount is applied until cart or checkout.' : '',
      processor: processor,
      productUrl: variant && variant.url ? variant.url : line.url,
      title: line.label + ' ' + tier.label + ' · ' + size + '″',
      reason: reason
    };
  }

  function recommend(answers) {
    if (answers.room === 'office') {
      var officeSize = answers.width === 'narrow' || answers.width === 'compact' ? '76″ · 3 × 2' : (answers.width === 'standard' ? '103″ · 4 × 3' : '130″ · 5 × 4');
      var officePitch = answers.distance === 'close' ? 'P0.93' : (answers.distance === 'medium' ? 'P1.2' : 'P1.5');
      var office = { seriesId:'office', series:'MicroLUX Office', aspect:'Collaboration format', cabinetGrid:officeSize.split(' · ')[1], size:officeSize.split(' · ')[0], tierId:'', tier:officePitch, pitch:officePitch, sku:'', price:'', productUrl:'/pages/contact', title:'MicroLUX Office · ' + officeSize + ' · ' + officePitch, reason:'This is a logical Office configuration for written-quote review. Touch capability with TU4K Pro is available by configuration. Price, included scope and delivery are confirmed only in writing.' };
      var officeAlt = { seriesId:'office', series:'MicroLUX Office', aspect:'Collaboration format', cabinetGrid:'4 × 3', size:'103″', tierId:'', tier:'P1.2', pitch:'P1.2', sku:'', price:'', productUrl:'/pages/contact', title:'MicroLUX Office · 103″ · 4 × 3 · P1.2', reason:'A second Office planning option for written-quote comparison. It is not a purchasable Shopify SKU.' };
      return { primary:office, secondary:officeAlt, intro:'Your answers point to MicroLUX Office. The finder is narrowing nine logical Office configurations for a written quote, not presenting an unpriced configuration as orderable.' };
    }
    if (answers.room === 'outdoor') {
      var outdoorPitch = answers.distance === 'very_far' ? 'P1.8' : 'P1.5';
      var outdoor = { seriesId:'outdoor', series:'MicroLUX Outdoor', aspect:'Fixed-installation project', cabinetGrid:'109″ or 136″', size:'', tierId:'', tier:outdoorPitch, pitch:outdoorPitch, sku:'', price:'', productUrl:'/pages/contact', title:'MicroLUX Outdoor · 109″ or 136″ · ' + outdoorPitch + ' · Written quote', reason:'Outdoor is available as a fixed-installation, IP67-rated MicroLUX wall. Select 109″ or 136″ at P1.5 or P1.8 in a written quote; price and included scope are confirmed only in that proposal.' };
      var outdoorReview = { seriesId:'outdoor-review', series:'Outdoor project review', aspect:'Site-specific', cabinetGrid:'', size:'', tierId:'', tier:'', pitch:'', sku:'', price:'', productUrl:'/pages/contact', title:'Confirm the site, size class and installation scope', reason:'A site review confirms dimensions, sight lines, power, drainage, mounting conditions and the written scope. Ascent remains a separate coming-soon product in development.' };
      return { primary:outdoor, secondary:outdoorReview, intro:'Your outdoor answer points to the fixed-installation MicroLUX Outdoor series. The finder recommends a pitch direction, then routes the unpriced configuration to written-quote review.' };
    }

    var seriesId;
    if (answers.room === 'theater' || answers.use === 'cinema') {
      seriesId = 'cinemascape';
    } else {
      seriesId = 'lifestyle';
    }
    var narrowCinemaNote = '';
    if (seriesId === 'cinemascape' && answers.width === 'narrow') {
      seriesId = 'lifestyle';
      narrowCinemaNote = ' The clear wall width is below the 94.5-inch minimum for a standard CinemaScape array, so Lifestyle is the buildable starting point; an expert can also review a custom cinema-first layout.';
    }

    var technicalTier = {
      close: 'prestige',
      medium: 'grand',
      far: 'signature',
      very_far: 'studio'
    }[answers.distance] || 'grand';

    var targetSize = sizeFor(seriesId, answers.width);
    var tierIds = ['prestige', 'grand', 'signature', 'studio'];
    var technicalTierIndex = tierIds.indexOf(technicalTier);
    var budgetBand = {
      entry: { min: 0, max: 19999 },
      mid: { min: 20000, max: 35000 },
      upper: { min: 35000, max: 60000 },
      open: { min: 0, max: Infinity }
    }[answers.budget] || { min: 0, max: Infinity };

    function rankedCandidates(candidateSeriesId) {
      var sizes = CATALOG[candidateSeriesId].sizes;
      var candidateTarget = sizeFor(candidateSeriesId, answers.width);
      var targetIndex = Math.max(0, sizes.indexOf(candidateTarget));
      var candidates = [];
      sizes.forEach(function (candidateSize, sizeIndex) {
        if (sizeIndex > targetIndex) return;
        tierIds.forEach(function (candidateTier, tierIndex) {
          var sku = buildSku(candidateSeriesId, candidateSize, candidateTier);
          var variant = findVariant(candidateSeriesId, candidateSize, candidateTier);
          var livePrice = variant && Number(variant.priceCents) > 0 ? Number(variant.priceCents) / 100 : 0;
          var priceValue = livePrice || foundingPriceForSku(sku);
          var overBudget = priceValue > budgetBand.max;
          var belowBand = budgetBand.min > 0 && priceValue < budgetBand.min;
          candidates.push({
            seriesId: candidateSeriesId,
            size: candidateSize,
            tierId: candidateTier,
            sku: sku,
            priceValue: priceValue,
            score: (overBudget ? 10000 + (priceValue - budgetBand.max) / 100 : 0) +
              (targetIndex - sizeIndex) * 100 +
              Math.abs(tierIndex - technicalTierIndex) * 24 +
              (belowBand ? 34 : 0)
          });
        });
      });
      return candidates.sort(function (a, b) { return a.score - b.score || b.priceValue - a.priceValue; });
    }

    var ranked = rankedCandidates(seriesId);
    var selected = ranked[0];
    var tierId = selected.tierId;
    var primarySize = selected.size;
    var seriesReason = {
      lifestyle: 'Lifestyle keeps native 16:9 content full-frame and gives mixed viewing, sports, gaming and multi-view the most flexible canvas.',
      cinemascape: 'CinemaScape gives a cinema-first room an ultrawide physical canvas and states the exact cabinet-grid ratio for every size.'
    }[seriesId];

    var pitchReason = {
      prestige: 'Prestige 0.9375 mm (P0.9) protects image continuity at the closest seating distances.',
      grand: 'Grand 1.25 mm (P1.2) is the strongest balance of fine pixel density and rational cost for this seating range.',
      signature: 'Signature 1.50 mm (P1.5) uses the viewing distance intelligently instead of charging for density your eye is unlikely to resolve.',
      studio: 'Studio 1.875 mm (P1.8) prioritizes physical scale and value where the longer viewing distance makes the pixel structure disappear.'
    }[tierId];

    var budgetNote = '';
    if (technicalTier !== tierId || primarySize !== targetSize) {
      budgetNote = ' The Screen Finder compared the published catalog prices against your investment range, available wall width and seating distance instead of recommending a configuration the budget answer rules out.';
    }
    var primary = configObject(seriesId, primarySize, tierId, seriesReason + ' ' + pitchReason + budgetNote + narrowCinemaNote);
    var secondary;

    if (seriesId === 'cinemascape' && answers.room !== 'theater') {
      var lifestyleSize = sizeFor('lifestyle', answers.width);
      var lifestyleCandidate = rankedCandidates('lifestyle')[0];
      secondary = configObject('lifestyle', lifestyleCandidate.size || lifestyleSize, lifestyleCandidate.tierId || tierId, 'Lifestyle is the price-aware 16:9 comparison. Choose it if sports, streaming, gaming or six-window layering will ultimately outweigh scope-film viewing.');
    } else if (seriesId === 'cinemascape' && answers.use !== 'cinema') {
      var alternateLifestyleSize = sizeFor('lifestyle', answers.width);
      var alternateLifestyle = rankedCandidates('lifestyle')[0];
      secondary = configObject('lifestyle', alternateLifestyle.size || alternateLifestyleSize, alternateLifestyle.tierId || tierId, 'The dedicated room points toward CinemaScape, but your mixed content answer makes Lifestyle a credible price-aware alternative with simpler full-frame 16:9 viewing.');
    } else {
      var alternate = ranked.filter(function (candidate) { return candidate.sku !== selected.sku; })[0];
      secondary = configObject(seriesId, alternate.size, alternate.tierId,
        'This is the next strongest catalog match after comparing published price, seating distance, available width and the tradeoff between scale and pixel density.');
    }

    var intro = 'Based on a ' + answers.distance.replace('_', ' ') + ' viewing distance and the available wall width, ' + primary.title + ' is the clearest place to start. The second card shows the tradeoff most worth comparing.';
    return { primary: primary, secondary: secondary, intro: intro };
  }

  function populateResult(root, recommendation) {
    var primary = recommendation.primary;
    var secondary = recommendation.secondary;
    $('[data-ml-result-intro]', root).textContent = recommendation.intro;

    function write(prefix, item) {
      $('[data-ml-' + prefix + '-series]', root).textContent = item.series + ' · ' + item.aspect;
      $('[data-ml-' + prefix + '-title]', root).textContent = item.title;
      $('[data-ml-' + prefix + '-reason]', root).textContent = item.reason;
      $('[data-ml-' + prefix + '-line]', root).textContent = item.series;
      var sizeNode = $('[data-ml-' + prefix + '-size]', root);
      var pitchNode = $('[data-ml-' + prefix + '-pitch]', root);
      var skuNode = $('[data-ml-' + prefix + '-sku]', root);
      var processorNode = $('[data-ml-' + prefix + '-processor]', root);
      var sizeText = item.size ? item.size + '″ diagonal' + (item.cabinetGrid ? ' · ' + item.cabinetGrid : '') : '';
      var pitchText = item.tier && item.pitch ? item.tier + ' · ' + item.pitch : '';
      sizeNode.textContent = sizeText;
      pitchNode.textContent = pitchText;
      skuNode.textContent = item.sku || '';
      if (processorNode) processorNode.textContent = item.processor || '';
      if (sizeNode.parentElement) sizeNode.parentElement.hidden = !sizeText;
      if (pitchNode.parentElement) pitchNode.parentElement.hidden = !pitchText;
      if (skuNode.parentElement) skuNode.parentElement.hidden = !item.sku;
      if (processorNode && processorNode.parentElement) processorNode.parentElement.hidden = !item.processor;
      var priceNode = $('[data-ml-' + prefix + '-price]', root);
      var compareNode = $('[data-ml-' + prefix + '-compare]', root);
      var promoNode = $('[data-ml-' + prefix + '-promo]', root);
      if (priceNode) {
        priceNode.textContent = item.price;
        var priceRow = priceNode.closest('div');
        if (priceRow) priceRow.hidden = !item.price;
      }
      if (compareNode) {
        compareNode.textContent = item.compareAt || '';
        compareNode.hidden = !item.compareAt;
      }
      if (promoNode) {
        promoNode.textContent = item.promoTerms || '';
        promoNode.hidden = !item.promoTerms;
      }
    }

    write('primary', primary);
    write('secondary', secondary);

    var scheduleBase = root.dataset.scheduleUrl || '/pages/schedule';
    var separator = scheduleBase.indexOf('?') === -1 ? '?' : '&';
    // Quote-only planning entries have no invented SKU; preserve the selected human-readable configuration in the proposal handoff.
    var primaryHandoff = primary.sku || primary.title;
    var alternateHandoff = secondary.sku || secondary.title;
    $('[data-ml-primary-cta]', root).href = scheduleBase + separator + 'recommendation=' + encodeURIComponent(primaryHandoff) + '&alternate=' + encodeURIComponent(alternateHandoff);
    $('[data-ml-secondary-cta]', root).href = scheduleBase + separator + 'recommendation=' + encodeURIComponent(primaryHandoff) + '&alternate=' + encodeURIComponent(alternateHandoff);

    try {
      window.sessionStorage.setItem('microluxRecommendation', JSON.stringify({
        primary: primary.sku,
        alternate: secondary.sku,
        primaryTitle: primary.title,
        alternateTitle: secondary.title
        ,primaryPrice: primary.price
        ,alternatePrice: secondary.price
      }));
    } catch (error) {
      // Recommendation storage is optional; the visible result remains complete.
    }
  }

  function initQuiz() {
    $$('[data-ml-quiz]').forEach(function (root) {
      var form = $('[data-ml-quiz-form]', root);
      var result = $('[data-ml-quiz-result]', root);
      var back = $('[data-ml-quiz-back]', root);
      var restart = $('[data-ml-quiz-restart]', root);
      var current = 1;
      var transitionTimer;

      function showStep(number, moveFocus) {
        current = Math.max(1, Math.min(5, number));
        $$('.ml-quiz-step', form).forEach(function (step) {
          var active = Number(step.dataset.mlStep) === current;
          step.hidden = !active;
          step.classList.toggle('is-active', active);
        });

        $('[data-ml-quiz-current]', root).textContent = current;
        $('[data-ml-quiz-percent]', root).textContent = (current * 20) + '%';
        $('[data-ml-quiz-bar]', root).style.width = (current * 20) + '%';
        $('[data-ml-quiz-progress]', root).setAttribute('aria-valuenow', String(current));
        back.disabled = current === 1;
        if (moveFocus) {
          var activeStep = $('.ml-quiz-step.is-active', form);
          if (activeStep) activeStep.focus({ preventScroll: true });
        }
      }

      function answers() {
        return {
          room: valueFrom(form, 'room'),
          use: valueFrom(form, 'use'),
          distance: valueFrom(form, 'distance'),
          width: valueFrom(form, 'width'),
          budget: valueFrom(form, 'budget')
        };
      }

      function finish() {
        var recommendation = recommend(answers());
        populateResult(root, recommendation);
        emitEvent('quiz_complete', {
          primary_configuration: recommendation.primary.sku,
          alternate_configuration: recommendation.secondary.sku,
          primary_series: recommendation.primary.seriesId
        });
        form.hidden = true;
        $('.ml-quiz-progress', root).hidden = true;
        result.hidden = false;
        result.focus({ preventScroll: true });
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      $$('input[type="radio"]', form).forEach(function (input) {
        input.addEventListener('change', function () {
          if (current === 1) emitEvent('quiz_start', { location: 'screen_finder' });
          window.clearTimeout(transitionTimer);
          transitionTimer = window.setTimeout(function () {
            if (current < 5) showStep(current + 1, true);
            else finish();
          }, 220);
        });
      });

      back.addEventListener('click', function () { showStep(current - 1, true); });

      restart.addEventListener('click', function () {
        form.reset();
        result.hidden = true;
        form.hidden = false;
        $('.ml-quiz-progress', root).hidden = false;
        showStep(1);
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      showStep(1);
    });
  }

  function currency(value) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
  }

  function initFinanceTools() {
    $$('[data-ml-finance-tool]').forEach(function (tool) {
      var amount = $('[data-ml-finance-amount]', tool);
      var apr = $('[data-ml-finance-apr]', tool);
      var amountOutput = $('[data-ml-finance-amount-output]', tool);
      var aprOutput = $('[data-ml-finance-apr-output]', tool);
      var paymentOutput = $('[data-ml-finance-payment]', tool);
      var summary = $('[data-ml-finance-summary]', tool);
      var pathOutput = $('[data-ml-finance-path-output]', tool);
      var term = 24;
      var financePath = 'shop';

      function calculate() {
        var principal = Number(amount.value);
        var annualRate = Number(apr.value);
        var financedPrincipal = principal;

        amountOutput.textContent = currency(principal);
        aprOutput.textContent = annualRate.toFixed(annualRate % 1 ? 2 : 0) + '%';

        if (financePath === 'shop') {
          if (pathOutput) pathOutput.textContent = 'Shop Pay Installments planning path';
          if (principal > 30000) {
            paymentOutput.textContent = 'Not eligible';
            summary.textContent = 'Shop Pay stops at a $30,000 order total. Talk with an expert about the direct 50/50 production-payment path.';
            return;
          }
        } else if (pathOutput) {
          pathOutput.textContent = 'Extended-term planning illustration';
        }

        var monthlyRate = annualRate / 100 / 12;
        var payment = monthlyRate === 0
          ? financedPrincipal / term
          : financedPrincipal * monthlyRate * Math.pow(1 + monthlyRate, term) / (Math.pow(1 + monthlyRate, term) - 1);
        var total = payment * term;

        paymentOutput.textContent = currency(payment) + '/mo';
        summary.textContent = term + ' months at ' + annualRate.toFixed(annualRate % 1 ? 2 : 0) + '% illustrative APR · ' + currency(total) + ' financed total';
      }

      amount.addEventListener('input', calculate);
      apr.addEventListener('input', calculate);
      amount.addEventListener('change', function () {
        emitEvent('finance_calculator_change', { amount: Number(amount.value), apr: Number(apr.value), term: term, path: financePath });
      });
      apr.addEventListener('change', function () {
        emitEvent('finance_calculator_change', { amount: Number(amount.value), apr: Number(apr.value), term: term, path: financePath });
      });
      $$('[data-ml-finance-term]', tool).forEach(function (button) {
        button.addEventListener('click', function () {
          term = Number(button.dataset.mlFinanceTerm);
          financePath = button.dataset.mlFinancePath || (term <= 24 ? 'shop' : 'lender');
          $$('[data-ml-finance-term]', tool).forEach(function (item) { item.classList.remove('is-active'); });
          button.classList.add('is-active');
          calculate();
          emitEvent('finance_calculator_change', { amount: Number(amount.value), apr: Number(apr.value), term: term, path: financePath });
        });
      });

      calculate();
    });
  }

  function carryQuizIntoContact() {
    var form = $('#MicroLuxHomeContact');
    if (!form) return;

    try {
      var saved = window.sessionStorage.getItem('microluxRecommendation');
      if (!saved) return;
      var recommendation = JSON.parse(saved);
      var primary = $('[data-ml-contact-recommendation]', form);
      var alternate = $('[data-ml-contact-alternate]', form);
      if (primary) primary.value = recommendation.primary || '';
      if (alternate) alternate.value = recommendation.alternate || '';
    } catch (error) {
      // Contact form remains fully functional without session storage.
    }
  }

  function initProductRequests() {
    $$('[data-ml-product-request]').forEach(function (root) {
      var select = $('[data-ml-product-request-select]', root);
      var processingSelect = $('[data-ml-processing-select]', root);
      var priceNode = $('[data-ml-product-request-price]', root);
      var compareNode = $('[data-ml-product-request-compare]', root);
      var directCartForm = $('[data-ml-product-direct-cart-id]', root);
      var directCartButton = $('[data-ml-product-direct-cart-button]', root);
      var directCartNote = $('[data-ml-product-direct-cart-note]', root);
      var controllerCartNote = $('[data-ml-product-controller-cart-note]', root);
      var installationQuote = $('[data-ml-installation-quote]', root);
      var controllerSuccessorHandle = root.dataset.mlControllerSuccessorHandle || '';
      var nativeControllerVariants = root.dataset.mlControllerNative === 'true';
      var controllerProductData = null;
      var controllerProductLoaded = nativeControllerVariants;
      var currentCartContext = null;
      var dimensionsNode = $('[data-ml-product-request-dimensions]', root);
      var resolutionNode = $('[data-ml-product-request-resolution]', root);
      var processorNode = $('[data-ml-product-request-processor]', root);
      var skuNode = $('[data-ml-product-request-sku]', root);
      var promoNode = $('[data-ml-product-request-promo]', root);
      var cta = $('[data-ml-product-request-cta]', root);
      var detailRoot = $('[data-ml-sku-detail]');
      var productHero = $('[data-ml-product-hero]');
      if (!select || !cta) return;

      var controllerCopy = {};
      try { controllerCopy = JSON.parse(root.dataset.mlControllerCopy || '{}'); } catch (error) {}
      var processingHelp = $('[data-ml-controller-help]', root);
      var processingCatalog = {
        'vx2000-pro': { key: 'vx2000-pro', model: 'VX2000Pro' },
        'mx40-pro': { key: 'mx40-pro', model: 'MX40 Pro' },
        'mx2000-pro': { key: 'mx2000-pro', model: 'MX2000 Pro' }
      };
      function allowedProcessingKeys(includedProcessor, sku) {
        if (vx2000EligibleSku(sku)) return ['vx2000-pro', 'mx40-pro'];
        return [processingKeyByModel[includedProcessor] || 'mx40-pro'];
      }
      var processingKeyByModel = {
        'VX2000Pro': 'vx2000-pro',
        'MX40 Pro': 'mx40-pro',
        'MX2000 Pro': 'mx2000-pro'
      };
      function controllerLabel(key, eligible) {
        if (eligible && key === 'vx2000-pro') return controllerCopy.vx_option || 'VX2000Pro · Included';
        if (eligible && key === 'mx40-pro') return controllerCopy.mx_option || 'MX40 Pro · +$3,300';
        return processingCatalog[key].model + ' · ' + (controllerCopy.included || 'Included');
      }
      var requestedProcessingKey = '';
      var processingInitialized = false;
      try {
        requestedProcessingKey = new URL(window.location.href).searchParams.get('processing') || '';
      } catch (error) {
        requestedProcessingKey = '';
      }

      function setText(context, selector, value) {
        var node = context ? $(selector, context) : null;
        if (node) node.textContent = value;
      }

      function includedProcessorForOption(option) {
        var sku = option && option.dataset ? (option.dataset.sku || '') : '';
        return processorForSku(sku);
      }

      function syncProcessingOptions(includedProcessor, sku, resetToIncluded) {
        if (!processingSelect) return;
        var allowedKeys = allowedProcessingKeys(includedProcessor, sku);
        var previousKey = processingSelect.value;
        var includedKey = processingKeyByModel[includedProcessor] || allowedKeys[0];
        var vxDefault = vx2000EligibleSku(sku) && allowedKeys.indexOf('vx2000-pro') !== -1;
        var defaultKey = vxDefault ? 'vx2000-pro' : includedKey;
        var desiredKey = resetToIncluded ? defaultKey : previousKey;
        if (!processingInitialized && requestedProcessingKey && allowedKeys.indexOf(requestedProcessingKey) !== -1) {
          desiredKey = requestedProcessingKey;
        }
        if (allowedKeys.indexOf(desiredKey) === -1) desiredKey = defaultKey;

        processingSelect.innerHTML = '';
        allowedKeys.forEach(function (key) {
          var item = processingCatalog[key];
          if (!item) return;
          var option = document.createElement('option');
          var isDefault = key === defaultKey;
          option.value = key;
          option.dataset.processorModel = item.model;
          option.textContent = controllerLabel(key, vxDefault);
          processingSelect.appendChild(option);
        });
        processingSelect.value = desiredKey;
        processingSelect.disabled = allowedKeys.length === 1;
        processingInitialized = true;
      }

      function selectedProcessingPackage(includedProcessor) {
        var includedKey = processingKeyByModel[includedProcessor] || 'mx40-pro';
        var selectedKey = processingSelect && processingCatalog[processingSelect.value] ?
          processingSelect.value :
          includedKey;
        return processingCatalog[selectedKey] || processingCatalog[includedKey];
      }

      function updateSkuDetail(option, specs, selectedProcessor, includedProcessor, scheduleHref, configuredPrice) {
        if (!detailRoot || !specs) return;
        var compare = $('[data-ml-sku-compare]', detailRoot);
        if (compare) {
          compare.textContent = option.dataset.compareAt || '';
          compare.hidden = !option.dataset.compareAt;
        }
        setText(detailRoot, '[data-ml-sku-price]', configuredPrice || option.dataset.price || 'Price setup required');
        setText(detailRoot, '[data-ml-sku-code]', specs.sku);
        setText(detailRoot, '[data-ml-sku-eyebrow]', specs.eyebrow);
        setText(detailRoot, '[data-ml-sku-title]', specs.detailHeading);
        setText(detailRoot, '[data-ml-sku-intro]', specs.intro);
        setText(detailRoot, '[data-ml-sku-imperial]', specs.imperial + ' visible face');
        setText(detailRoot, '[data-ml-sku-array]', specs.cols + ' × ' + specs.rows + ' cabinets');
        setText(detailRoot, '[data-ml-sku-actual]', specs.actual + '″ actual diagonal');
        setText(detailRoot, '[data-ml-sku-tier-title]', specs.tier + ' is about the seat, not the upsell.');
        setText(detailRoot, '[data-ml-sku-tier-story]', specs.tierStory);
        setText(detailRoot, '[data-ml-sku-nominal]', specs.size);
        setText(detailRoot, '[data-ml-sku-actual-inline]', specs.actual);
        var dimensions = $('[data-ml-sku-dimensions]', detailRoot);
        if (dimensions) dimensions.innerHTML = specs.metric + '<small>' + specs.imperial + '</small>';
        setText(detailRoot, '[data-ml-sku-ratio]', specs.ratio);
        setText(detailRoot, '[data-ml-sku-array-inline]', specs.cols + ' × ' + specs.rows);
        setText(detailRoot, '[data-ml-sku-cabinet-count]', String(specs.cabinetCount));
        setText(detailRoot, '[data-ml-sku-pitch]', specs.pitch);
        setText(detailRoot, '[data-ml-sku-tier]', specs.tier + ' tier');
        setText(detailRoot, '[data-ml-sku-cabinet-resolution]', specs.cabinetResolution);
        setText(detailRoot, '[data-ml-sku-resolution]', specs.resolution);
        setText(detailRoot, '[data-ml-sku-pixels]', specs.totalPixelsLabel);
        setText(detailRoot, '[data-ml-sku-processor]', selectedProcessor);
        setText(detailRoot, '[data-ml-sku-included-array]', specs.cabinetCount + '-cabinet');
        setText(detailRoot, '[data-ml-sku-included-processor]', vx2000EligibleSku(specs.sku) ? selectedProcessor : includedProcessor);
        var visual = $('[data-ml-cabinet-visual]', detailRoot);
        if (visual) {
          visual.style.setProperty('--ml-cabinet-cols', specs.cols);
          visual.style.setProperty('--ml-cabinet-rows', specs.rows);
          visual.style.aspectRatio = (specs.cols * 16) + ' / ' + (specs.rows * 9);
        }
        var expertLink = $('[data-ml-sku-expert-link]', detailRoot);
        if (expertLink) expertLink.href = scheduleHref;
      }

      function updateProductHero(option, specs, configuredPrice) {
        if (!productHero || !specs) return;
        setText(productHero, '[data-ml-product-hero-eyebrow]', specs.eyebrow);
        setText(productHero, '[data-ml-product-hero-title]', specs.heading);
        setText(productHero, '[data-ml-product-hero-copy]', specs.heroCopy);
        setText(productHero, '[data-ml-product-hero-price]', configuredPrice || option.dataset.price || 'Price setup required');
        setText(productHero, '[data-ml-product-hero-sku]', specs.sku);
        setText(productHero, '[data-ml-product-hero-resolution]', specs.resolution + ' native');
        setText(productHero, '[data-ml-product-hero-dimensions]', specs.metric + ' · ' + specs.imperial);
        var heroOffer = $('[data-ml-product-hero-offer]', productHero);
        var showSignatureOffer = root.dataset.signatureOfferEnabled === 'true';
        if (heroOffer) {
          if (showSignatureOffer && !heroOffer.textContent.trim()) {
            heroOffer.innerHTML = '<strong>Grand Opening:</strong> Enter code GRANDOPENING10 at checkout by September 30, 2026 for 10% off. Prices shown are regular configuration prices.';
          }
          heroOffer.hidden = !showSignatureOffer;
        }
      }

      function loadProductHandle(handle, callback) {
        if (!handle || !window.fetch) {
          callback(null);
          return;
        }
        window.fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (data) { callback(data); })
          .catch(function () { callback(null); });
      }

      function nativeOptionForController(sku, controllerKey) {
        var wantedSku = targetSkuForController(sku, controllerKey);
        return Array.prototype.slice.call(select.options).find(function (candidate) {
          return String(candidate.dataset.sku || '') === wantedSku;
        }) || null;
      }

      function syncNativeProcessing(option) {
        if (!processingSelect) return;
        var baseSku = baseConfigurationSku(option.dataset.sku || '');
        var currentKey = controllerKeyForModel(option.dataset.processor || '');
        processingSelect.innerHTML = '';
        var eligible = vx2000EligibleSku(baseSku);
        var nativeKeys = eligible ? ['vx2000-pro', 'mx40-pro'] : [currentKey];
        nativeKeys.forEach(function (key) {
          var item = processingCatalog[key];
          if (!item) return;
          var node = document.createElement('option');
          node.value = key;
          node.dataset.processorModel = item.model;
          node.textContent = controllerLabel(key, eligible);
          processingSelect.appendChild(node);
        });
        processingSelect.value = currentKey;
        processingSelect.disabled = nativeKeys.length === 1;
        processingInitialized = true;
      }

      function updateRequest(shouldUpdateUrl, resetProcessing) {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var selectedSku = option.dataset.sku || '';
        var baseSku = baseConfigurationSku(selectedSku);
        var specs = skuSpecifications(baseSku);
        var isLaunchSpecial = root.dataset.signatureOfferEnabled === 'true';
        var native = nativeControllerVariants && option.dataset.nativeControllerVariant === 'true';
        var includedProcessor = native ? (option.dataset.processor || processorForSku(baseSku)) : includedProcessorForOption(option);
        if (native) syncNativeProcessing(option);
        else syncProcessingOptions(includedProcessor, baseSku, resetProcessing);
        var processingPackage = native ?
          (processingCatalog[controllerKeyForModel(includedProcessor)] || processingCatalog['mx40-pro']) :
          selectedProcessingPackage(includedProcessor);
        var selectedProcessor = processingPackage ? processingPackage.model : includedProcessor;
        var resolvedVariantId = option.value;
        var resolvedAvailable = option.dataset.available === 'true';
        var optionPriceCents = Number(option.dataset.priceCents || 0);
        var configuredPriceCents = optionPriceCents > 0
          ? optionPriceCents
          : foundingPriceForSku(baseSku) * 100;
        var priceResolved = true;

        if (!native && vx2000EligibleSku(baseSku)) {
          var wantedKey = processingPackage ? processingPackage.key : 'vx2000-pro';
          var matched = authoritativeVariant(controllerProductData, baseSku, wantedKey);
          if (matched) {
            resolvedVariantId = String(matched.id);
            resolvedAvailable = matched.available === true;
            configuredPriceCents = moneyCentsFromVariant(matched);
          } else if (wantedKey === 'mx40-pro') {
            resolvedVariantId = '';
            resolvedAvailable = false;
            configuredPriceCents = optionPriceCents > 0 ? optionPriceCents + 330000 : 0;
            priceResolved = Number.isFinite(configuredPriceCents) && configuredPriceCents > 0;
          }
        }

        var displayedPriceCents = configuredPriceCents;
        var configuredPrice = priceResolved ? formattedCatalogPriceFromCents(configuredPriceCents) : 'Configuration price is loading';
        var displayedPrice = priceResolved ? formattedCatalogPriceFromCents(displayedPriceCents) : 'Configuration price is loading';

        if (priceNode) priceNode.textContent = displayedPrice;
        if (compareNode) {
          compareNode.textContent = !isLaunchSpecial ? (option.dataset.compareAt || '') : '';
          compareNode.hidden = !compareNode.textContent;
        }
        if (dimensionsNode && specs) dimensionsNode.innerHTML = specs.metric + '<small>' + specs.imperial + '</small>';
        if (resolutionNode && specs) resolutionNode.textContent = specs.resolution;
        if (processorNode) processorNode.textContent = selectedProcessor;
        if (skuNode) skuNode.textContent = selectedSku || 'Configuration setup required';
        if (promoNode) promoNode.hidden = !isLaunchSpecial;
        var canDirectPurchase = priceResolved && resolvedAvailable;
        if (directCartForm) {
          directCartForm.value = resolvedVariantId;
          directCartForm.closest('form').hidden = !canDirectPurchase;
        }
        if (directCartButton) directCartButton.disabled = !canDirectPurchase;
        if (directCartNote) {
          directCartNote.hidden = !canDirectPurchase;
          directCartNote.textContent = controllerCopy.cart_note || 'Your selected screen and controller are added at the displayed price. The screen discount applies at checkout.';
        }
        if (controllerCartNote) controllerCartNote.hidden = canDirectPurchase || !vx2000EligibleSku(baseSku);
        if (processingHelp) {
          var helpUrl = new URL(processingHelp.href, window.location.href);
          helpUrl.searchParams.set('variant', option.value);
          helpUrl.searchParams.set('processing', processingPackage.key);
          var previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (previewId) helpUrl.searchParams.set('preview_theme_id', previewId);
          processingHelp.href = helpUrl.toString();
          processingHelp.hidden = !vx2000EligibleSku(baseSku);
        }

        var scheduleBase = root.dataset.scheduleUrl || '/pages/schedule';
        var separator = scheduleBase.indexOf('?') === -1 ? '?' : '&';
        var requestedSku = /-MX40P$/.test(selectedSku) ? selectedSku :
          (processingPackage && processingPackage.key === 'mx40-pro' && vx2000EligibleSku(baseSku) ? baseSku + '-MX40P' : (selectedSku || baseSku));
        var controllerDeltaCents = 0;
        if (/-MX40P$/.test(requestedSku)) {
          var baseOption = Array.prototype.find.call(select.options, function (candidate) { return candidate.dataset.sku === baseSku; });
          var basePriceCents = baseOption ? Number(baseOption.dataset.priceCents || 0) : 0;
          controllerDeltaCents = priceResolved && basePriceCents > 0 && configuredPriceCents > basePriceCents ? configuredPriceCents - basePriceCents : '';
        }
        var scheduleHref = scheduleBase + separator +
          'recommendation=' + encodeURIComponent(baseSku) +
          '&variant=' + encodeURIComponent(resolvedVariantId) +
          '&product=' + encodeURIComponent(root.dataset.productTitle || 'MicroLUX wall') +
          '&processing=' + encodeURIComponent(selectedProcessor) +
          '&processing_package=' + encodeURIComponent(processingPackage ? processingPackage.key : '') +
          '&included_processor=' + encodeURIComponent(includedProcessor) +
          '&configuration_price_cents=' + encodeURIComponent(configuredPriceCents) +
          '&configuration_price=' + encodeURIComponent(priceResolved ? formattedCatalogPriceFromCents(configuredPriceCents) : '') +
          '&installation_pricing=quoted_separately' +
          '&displayed_total_cents=' + encodeURIComponent(displayedPriceCents) +
          '&controller_delta_cents=' + encodeURIComponent(controllerDeltaCents) +
          '&selected_sku=' + encodeURIComponent(requestedSku);
        cta.href = scheduleHref;
        if (installationQuote) {
          var quoteUrl = new URL(root.dataset.mlInstallationQuoteUrl || '/pages/schedule', window.location.href);
          quoteUrl.searchParams.set('interest', 'installation');
          quoteUrl.searchParams.set('recommendation', baseSku);
          quoteUrl.searchParams.set('processing', selectedProcessor);
          quoteUrl.searchParams.set('installation_pricing', 'quoted_separately');
          var quotePreviewId = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (quotePreviewId) quoteUrl.searchParams.set('preview_theme_id', quotePreviewId);
          quoteUrl.hash = 'MicroLuxScheduleRequest';
          installationQuote.href = quoteUrl.toString();
        }
        cta.setAttribute('aria-label', 'Request ' + (selectedSku || option.textContent.trim()) + ' with ' + selectedProcessor + ' processing');
        updateSkuDetail(option, specs, selectedProcessor, includedProcessor, scheduleHref, configuredPrice);
        updateProductHero(option, specs, configuredPrice);
        currentCartContext = {
          canDirectPurchase: canDirectPurchase,
          variantId: resolvedVariantId
        };
        try {
          window.sessionStorage.setItem('microluxConfiguration', JSON.stringify({
            sku: selectedSku, variantId: resolvedVariantId, selectedController: selectedProcessor,
            controllerKey: processingPackage ? processingPackage.key : '',
            regularPriceCents: configuredPriceCents, configurationPriceCents: configuredPriceCents,
            configurationPrice: priceResolved ? formattedCatalogPriceFromCents(configuredPriceCents) : '',
            displayedPriceCents: displayedPriceCents, displayedPrice: displayedPrice,
            controllerDeltaCents: controllerDeltaCents, installationSelected: false,
            installationDraftVariantId: '',
            installationPriceCents: null,
            installationPricing: 'quoted_separately',
            installationDraftActive: false
          }));
        } catch (error) {}
        if (shouldUpdateUrl && window.history && window.URL) {
          var nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('variant', resolvedVariantId || option.value);
          if (processingPackage) nextUrl.searchParams.set('processing', processingPackage.key);
          window.history.replaceState({ variant: resolvedVariantId, processing: processingPackage ? processingPackage.key : '' }, '', nextUrl.pathname + nextUrl.search + nextUrl.hash);
          if (specs) document.title = specs.detailHeading + ' | MicroLUX';
        }
      }

      if (directCartForm) {
        directCartForm.closest('form').addEventListener('submit', function (event) {
          if (!currentCartContext || !currentCartContext.canDirectPurchase) {
            event.preventDefault();
            return;
          }

        });
      }

      if (!nativeControllerVariants && controllerSuccessorHandle) {
        loadProductHandle(controllerSuccessorHandle, function (data) {
          controllerProductData = data;
          controllerProductLoaded = true;
          updateRequest(false, false);
        });
      }

      select.addEventListener('change', function () {
        updateRequest(true, true);
        emitEvent('configuration_select', { sku: select.options[select.selectedIndex].dataset.sku || '' });
      });
      if (processingSelect) {
        processingSelect.addEventListener('change', function () {
          if (nativeControllerVariants) {
            var currentOption = select.options[select.selectedIndex];
            var target = nativeOptionForController(currentOption.dataset.sku || '', processingSelect.value || '');
            if (target) select.value = target.value;
          }
          updateRequest(true, false);
          emitEvent('processing_package_select', {
            sku: select.options[select.selectedIndex].dataset.sku || '',
            processing: processingSelect.value || ''
          });
        });
      }
      updateRequest(false, false);
    });
  }

  function showScheduleRecommendation() {
    var box = $('[data-ml-schedule-recommendation]');
    if (!box || !window.URLSearchParams) return;

    var params = new URLSearchParams(window.location.search);
    var primary = params.get('recommendation');
    var alternate = params.get('alternate');
    if (!primary) return;

    $('[data-ml-schedule-primary]', box).textContent = primary;
    var formPrimary = $('[data-ml-schedule-form-primary]');
    var formAlternate = $('[data-ml-schedule-form-alternate]');
    if (formPrimary) formPrimary.value = primary;
    var installationScreen = $('[data-ml-installation-screen]');
    if (installationScreen && !installationScreen.value) installationScreen.value = primary;
    if (formAlternate) formAlternate.value = alternate || '';
    if (alternate) {
      $('[data-ml-schedule-alternate]', box).textContent = alternate;
    } else {
      var altWrap = $('[data-ml-schedule-alt-wrap]', box);
      if (altWrap) altWrap.hidden = true;
    }
    box.hidden = false;
  }

  function initCalendly() {
    var widget = $('.calendly-inline-widget[data-ml-calendly]');
    if (!widget) return;

    var url = new URL(widget.dataset.url, window.location.href);
    var params = new URLSearchParams(window.location.search);
    var primary = params.get('recommendation');
    var alternate = params.get('alternate');
    url.searchParams.set('hide_gdpr_banner', '1');
    url.searchParams.set('primary_color', 'a9864a');
    url.searchParams.set('utm_source', 'microlux_site');
    url.searchParams.set('utm_medium', 'website');
    if (primary) {
      url.searchParams.set('utm_campaign', 'screen_finder');
      url.searchParams.set('utm_content', primary + (alternate ? '__' + alternate : ''));
    }
    widget.dataset.url = url.toString();

    var script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.addEventListener('load', function () { emitEvent('scheduler_loaded', { location: 'schedule_page' }); });
    document.body.appendChild(script);
  }


  function initVisualDisclosureMarkers() {
    var nodes = document.querySelectorAll('.ml-concept-badge, .ph-note, .ml-home-hero__visual-note, figcaption span');

    Array.prototype.forEach.call(nodes, function (node) {
      if (node.closest('#site-disclosures') || node.classList.contains('ml-visual-disclosure-marker')) return;

      var label = (node.textContent || '').replace(/\\s+/g, ' ').trim();
      if (!/concept (visualization|visualizations|image|images)/i.test(label)) return;

      node.textContent = '';
      node.classList.add('ml-visual-disclosure-marker');

      var link = document.createElement('a');
      link.href = '#site-disclosures';
      link.textContent = '*';
      link.setAttribute('aria-label', label + '. See the visual-media disclosure at the end of this page.');
      link.setAttribute('title', 'See visual-media disclosure');
      node.appendChild(link);
    });
  }

  function init() {
    initVisualDisclosureMarkers();
    initReveals();
    initTrackedActions();
    initComparisonSliders();
    initLayering();
    initQuiz();
    initFinanceTools();
    initProductRequests();
    carryQuizIntoContact();
    showScheduleRecommendation();
    initCalendly();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* MicroLUX Google Search QA attribution layer — unpublished v11.6 */
(function () {
  var PARAM_KEYS = [
    'gclid', 'gbraid', 'wbraid',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'keyword', 'matchtype', 'device', 'network',
    'campaign_id', 'adgroup_id', 'creative'
  ];
  var STORAGE_KEY = 'microlux_attribution_v1';
  var SESSION_KEY = 'microlux_attribution_session_id';

  function safeParse(value) {
    try { return JSON.parse(value || '{}'); } catch (error) { return {}; }
  }

  function safeStore(key, value, sessionOnly) {
    try {
      (sessionOnly ? window.sessionStorage : window.localStorage).setItem(key, value);
    } catch (error) {}
  }

  function readStore(key, sessionOnly) {
    try {
      return (sessionOnly ? window.sessionStorage : window.localStorage).getItem(key);
    } catch (error) {
      return null;
    }
  }

  function makeId(prefix) {
    return prefix + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function sessionId() {
    var id = readStore(SESSION_KEY, true);
    if (!id) {
      id = makeId('ml');
      safeStore(SESSION_KEY, id, true);
    }
    return id;
  }

  function queryValues() {
    var values = {};
    if (!window.URLSearchParams) return values;
    var query = new URLSearchParams(window.location.search);
    PARAM_KEYS.forEach(function (key) {
      var value = query.get(key);
      if (value) values[key] = value;
    });
    return values;
  }

  function hasValues(object) {
    return Object.keys(object || {}).length > 0;
  }

  function captureAttribution() {
    var saved = safeParse(readStore(STORAGE_KEY));
    var current = queryValues();
    var touch = {
      landing_page: window.location.href,
      path: window.location.pathname,
      referrer: document.referrer || '',
      timestamp: new Date().toISOString(),
      params: current
    };

    if (!saved.first) saved.first = touch;
    if (hasValues(current)) saved.latest = touch;
    if (!saved.latest) saved.latest = saved.first;
    safeStore(STORAGE_KEY, JSON.stringify(saved));
    return saved;
  }

  function effectiveParams(attribution) {
    var current = queryValues();
    if (hasValues(current)) return current;
    return (attribution.latest && attribution.latest.params) || {};
  }

  function ensureHidden(form, name, value) {
    if (!form || value === undefined || value === null) return;
    var field = form.querySelector('[name="' + name.replace(/"/g, '\"') + '"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = String(value);
    field.setAttribute('value', String(value));
  }

  function hydrateForm(form, attribution) {
    if (!form) return;
    var params = effectiveParams(attribution);
    var recommendation = new URLSearchParams(window.location.search).get('recommendation') || '';
    var alternate = new URLSearchParams(window.location.search).get('alternate') || '';
    var requestedSkuParam = new URLSearchParams(window.location.search).get('selected_sku') || '';
    var selectedSku = (/^ML-[A-Z]{2}-[0-9]+-[A-Z0-9]+(-MX40P)?$/.test(requestedSkuParam) ? requestedSkuParam : '') || form.getAttribute('data-ml-selected-sku') || recommendation || '';
    var variantId = form.getAttribute('data-ml-variant-id') || new URLSearchParams(window.location.search).get('variant') || '';
    var handoffQuery = new URLSearchParams(window.location.search);
    var projectType = handoffQuery.get('project_type') || '';
    var leadPriority = handoffQuery.get('lead_priority') || '';
    var leadOwner = handoffQuery.get('lead_owner') || '';
    var handoffSource = handoffQuery.get('handoff_source') || '';
    var handoffId = handoffQuery.get('handoff_id') || '';
    var savedConfiguration = {};
    try { savedConfiguration = JSON.parse(window.sessionStorage.getItem('microluxConfiguration') || '{}'); } catch (error) {}
    var selectedController = handoffQuery.get('processing') || savedConfiguration.selectedController || '';
    var configurationPriceCents = handoffQuery.get('configuration_price_cents') || savedConfiguration.configurationPriceCents || '';
    var configurationPrice = handoffQuery.get('configuration_price') || savedConfiguration.configurationPrice || '';
    var controllerDeltaCents = handoffQuery.get('controller_delta_cents') || savedConfiguration.controllerDeltaCents || '';

    ensureHidden(form, 'contact[source]', params.utm_source || (document.referrer ? 'referral' : 'direct'));
    ensureHidden(form, 'contact[selected_sku]', selectedSku);
    ensureHidden(form, 'contact[variant_id]', variantId);
    ensureHidden(form, 'contact[selected_controller]', selectedController);
    ensureHidden(form, 'contact[configuration_price_cents]', configurationPriceCents);
    ensureHidden(form, 'contact[configuration_price]', configurationPrice);
    ensureHidden(form, 'contact[controller_delta_cents]', controllerDeltaCents);
    ensureHidden(form, 'contact[recommended_configuration]', recommendation || selectedSku);
    ensureHidden(form, 'contact[alternate_configuration]', alternate);
    ensureHidden(form, 'contact[landing_page_url]', window.location.href);
    ensureHidden(form, 'contact[first_landing_page]', attribution.first && attribution.first.landing_page);
    ensureHidden(form, 'contact[first_touch_timestamp]', attribution.first && attribution.first.timestamp);
    ensureHidden(form, 'contact[conversion_timestamp]', new Date().toISOString());
    ensureHidden(form, 'contact[referring_url]', attribution.first && attribution.first.referrer);
    ensureHidden(form, 'contact[project_type]', projectType);
    ensureHidden(form, 'contact[lead_priority]', leadPriority);
    ensureHidden(form, 'contact[lead_owner]', leadOwner);
    ensureHidden(form, 'contact[handoff_source]', handoffSource);
    ensureHidden(form, 'contact[handoff_id]', handoffId);
    ensureHidden(form, 'contact[coverage_window]', projectType === 'custom_wall' ? 'Mon-Fri 8:00 AM-5:00 PM ET' : '');
    ensureHidden(form, 'contact[routing_label]', projectType === 'custom_wall' ? 'HIGH-VALUE CUSTOM WALL — HUMAN REVIEW' : '');
    ensureHidden(form, 'contact[primary_owner]', projectType === 'custom_wall' ? 'Chris Dunn' : '');
    ensureHidden(form, 'contact[backup_owner]', projectType === 'custom_wall' ? 'UNASSIGNED — LAUNCH BLOCKER' : '');
    ensureHidden(form, 'contact[assignment_escalation]', projectType === 'custom_wall' ? 'Escalate if unassigned after 15 minutes' : '');
    ensureHidden(form, 'contact[response_escalation]', projectType === 'custom_wall' ? 'Escalate if no human response within one covered business hour' : '');
    ensureHidden(form, 'contact[after_hours_policy]', projectType === 'custom_wall' ? 'Enter the next covered interval' : '');
    ensureHidden(form, 'contact[urgent_escalation]', projectType === 'custom_wall' ? 'Urgent legal or payment-risk concerns escalate immediately' : '');

    var firstParams = (attribution.first && attribution.first.params) || {};
    var latestParams = (attribution.latest && attribution.latest.params) || {};
    PARAM_KEYS.forEach(function (key) {
      ensureHidden(form, 'contact[' + key + ']', params[key] || '');
      ensureHidden(form, 'contact[first_touch_' + key + ']', firstParams[key] || '');
      ensureHidden(form, 'contact[latest_touch_' + key + ']', latestParams[key] || '');
    });
    ensureHidden(form, 'contact[first_source]', firstParams.utm_source || '');
    ensureHidden(form, 'contact[latest_source]', latestParams.utm_source || '');
    ensureHidden(form, 'contact[latest_landing_page]', attribution.latest && attribution.latest.landing_page);
    ensureHidden(form, 'contact[latest_touch_timestamp]', attribution.latest && attribution.latest.timestamp);
    ensureHidden(form, 'contact[latest_referring_url]', attribution.latest && attribution.latest.referrer);
    form.setAttribute('data-ml-qa-hydrated', 'true');
    form.setAttribute('data-ml-qa-first-attribution-count', String(PARAM_KEYS.filter(function (key) { return !!firstParams[key]; }).length));
    form.setAttribute('data-ml-qa-latest-attribution-count', String(PARAM_KEYS.filter(function (key) { return !!latestParams[key]; }).length));
  }

  function decorateScheduleLink(anchor, attribution) {
    if (!anchor || !anchor.href) return;
    var url;
    try { url = new URL(anchor.href, window.location.origin); } catch (error) { return; }
    if (url.origin !== window.location.origin || url.pathname !== '/pages/schedule') return;
    var params = effectiveParams(attribution);
    PARAM_KEYS.forEach(function (key) {
      if (params[key] && !url.searchParams.has(key)) url.searchParams.set(key, params[key]);
    });
    if (!url.searchParams.has('first_landing_page') && attribution.first) {
      url.searchParams.set('first_landing_page', attribution.first.landing_page);
    }
    anchor.href = url.pathname + url.search + url.hash;
  }

  function pushEvent(name, detail) {
    var payload = detail || {};
    payload.event = name;
    payload.event_id = payload.event_id || makeId(name);
    payload.ml_session_id = sessionId();
    payload.page_location = window.location.href;
    payload.page_path = window.location.pathname;
    payload.event_timestamp = new Date().toISOString();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      document.dispatchEvent(new CustomEvent('microlux:' + name, { detail: payload }));
    } catch (error) {}
    return payload;
  }

  function initCustomWallHandoff(attribution) {
    var query = new URLSearchParams(window.location.search);
    var customPaths = ['/products/lifestyle-microled-wall', '/products/cinemascape-microled-wall', '/pages/lifestyle', '/pages/cinemascape'];
    var isCustomEntry = customPaths.indexOf(window.location.pathname) !== -1;
    var isCustomComposer = window.location.pathname === '/pages/schedule' && query.get('project_type') === 'custom_wall';
    var handoffId = query.get('handoff_id') || ('MLH-' + sessionId());

    if (!document.getElementById('ml-custom-handoff-style')) {
      var style = document.createElement('style');
      style.id = 'ml-custom-handoff-style';
      style.textContent = '.ml-custom-handoff{background:#0e1c27;color:#fff}.ml-custom-handoff__inner{max-width:1180px;margin:0 auto;padding:56px 24px;display:grid;grid-template-columns:minmax(0,1.5fr) minmax(260px,.7fr);gap:32px;align-items:center}.ml-custom-handoff__eyebrow{color:#d6ae62;font-size:.78rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase}.ml-custom-handoff h2{color:#fff;margin:.35rem 0 .75rem;font-size:clamp(2rem,4vw,3.6rem);line-height:1.02}.ml-custom-handoff p{max-width:760px;color:#e8edf1;line-height:1.65}.ml-custom-handoff__card{border:1px solid rgba(214,174,98,.5);background:rgba(255,255,255,.05);padding:24px;border-radius:4px}.ml-custom-handoff__owner{display:block;color:#d6ae62;font-weight:700;margin-bottom:8px}.ml-custom-handoff__actions{display:flex;flex-wrap:wrap;gap:12px;margin-top:20px}.ml-custom-handoff__button{display:inline-flex;min-height:48px;align-items:center;justify-content:center;padding:12px 18px;background:#d6ae62;color:#111!important;text-decoration:none;font-weight:700}.ml-custom-handoff__phone{display:inline-flex;min-height:48px;align-items:center;color:#fff!important}.ml-custom-composer-note{border:1px solid #d6ae62;background:#fff8e9;padding:18px 20px;margin:0 0 24px}.ml-custom-composer-note strong{display:block;color:#6a4a10;margin-bottom:5px}@media(max-width:760px){.ml-custom-handoff__inner{grid-template-columns:1fr;padding:40px 20px}.ml-custom-handoff__actions{display:grid}.ml-custom-handoff__button,.ml-custom-handoff__phone{width:calc(100% - 96px);justify-content:flex-start}}';
      document.head.appendChild(style);
    }

    if (isCustomEntry && !document.getElementById('ml-custom-handoff')) {
      var hero = document.querySelector('main .ml-product-hero, main .hero');
      var main = document.querySelector('main');
      var section = document.createElement('section');
      section.id = 'ml-custom-handoff';
      section.className = 'ml-custom-handoff';
      section.setAttribute('aria-labelledby', 'ml-custom-handoff-title');
      section.innerHTML = '<div class="ml-custom-handoff__inner"><div><div class="ml-custom-handoff__eyebrow">Custom screen</div><h2 id="ml-custom-handoff-title">Your custom screen starts here.</h2><p>Share your vision, dimensions and how you’ll use the screen. MicroLUX will help shape the right configuration and provide a clear written proposal.</p><div class="ml-custom-handoff__actions"><a class="ml-custom-handoff__button" href="/pages/schedule">Send custom-wall details →</a><a class="ml-custom-handoff__phone" href="tel:+18335339255">Call 1-833-LED-WALL</a></div></div></div>';
      var cta = section.querySelector('.ml-custom-handoff__button');
      var url = new URL('/pages/schedule', window.location.origin);
      url.searchParams.set('project_type', 'custom_wall');
      url.searchParams.set('lead_priority', 'high_value');
      url.searchParams.set('lead_owner', 'chris_dunn');
      url.searchParams.set('handoff_source', 'product_custom_wall');
      url.searchParams.set('handoff_id', handoffId);
      cta.href = url.pathname + url.search;
      decorateScheduleLink(cta, attribution);
      cta.addEventListener('click', function () {
        pushEvent('human_handoff_open', { project_type: 'custom_wall', lead_priority: 'high_value', lead_owner: 'chris_dunn', handoff_source: 'product_custom_wall', handoff_id: handoffId });
      });
      if (hero) hero.insertAdjacentElement('afterend', section);
      else if (main) main.insertBefore(section, main.firstChild);
      pushEvent('human_handoff_view', { project_type: 'custom_wall', lead_owner: 'chris_dunn', handoff_id: handoffId });
      document.body.setAttribute('data-ml-qa-human-handoff', 'product-ready');
    }

    if (isCustomComposer) {
      var form = document.querySelector('form[action*="/contact"], form[data-ml-attribution-form]');
      if (form) {
        form.setAttribute('data-ml-form-id', 'custom-wall-handoff');
        form.setAttribute('data-ml-handoff-id', handoffId);
        var syncHandoffFields = function () {
          ensureHidden(form, 'contact[project_type]', 'custom_wall');
          ensureHidden(form, 'contact[lead_priority]', query.get('lead_priority') || 'high_value');
          ensureHidden(form, 'contact[lead_owner]', query.get('lead_owner') || 'chris_dunn');
          ensureHidden(form, 'contact[handoff_source]', query.get('handoff_source') || 'unknown');
          ensureHidden(form, 'contact[handoff_id]', handoffId);
          ensureHidden(form, 'contact[coverage_window]', 'Mon-Fri 8:00 AM-5:00 PM ET');
        };
        syncHandoffFields();
        setTimeout(syncHandoffFields, 0);
        form.addEventListener('submit', syncHandoffFields, true);
        if (!document.getElementById('ml-custom-composer-note')) {
          var note = document.createElement('div');
          note.id = 'ml-custom-composer-note';
          note.className = 'ml-custom-composer-note';
          note.setAttribute('role', 'status');
          note.innerHTML = '<strong>Your custom screen starts here.</strong><span>Share your vision, dimensions and how you’ll use the screen. MicroLUX will help shape the right configuration and provide a clear written proposal.</span>';
          form.insertBefore(note, form.firstChild);
        }
        pushEvent('human_handoff_form_view', { project_type: 'custom_wall', lead_priority: query.get('lead_priority') || 'high_value', lead_owner: query.get('lead_owner') || 'chris_dunn', handoff_source: query.get('handoff_source') || 'unknown', handoff_id: handoffId });
        document.body.setAttribute('data-ml-qa-human-handoff', 'composer-ready');
      }
    }
  }

  function init() {
    var attribution = captureAttribution();
    var params = effectiveParams(attribution);
    initCustomWallHandoff(attribution);
    document.querySelectorAll('a[href]').forEach(function (anchor) {
      decorateScheduleLink(anchor, attribution);
    });

    var forms = document.querySelectorAll('form[action*="/contact"], form[data-ml-attribution-form]');
    forms.forEach(function (form) {
      hydrateForm(form, attribution);
      var started = false;
      form.setAttribute('data-ml-qa-form-start-event', 'armed');
      form.addEventListener('input', function () {
        if (started || form.getAttribute('data-ml-form-start-fired') === 'true') return;
        started = true;
        form.setAttribute('data-ml-form-start-fired', 'true');
        pushEvent('form_start', {
          form_id: form.id || form.getAttribute('data-ml-form-id') || 'contact',
          selected_sku: form.getAttribute('data-ml-selected-sku') || 'ML-LS-108-G125',
          utm_source: params.utm_source || '',
          utm_campaign: params.utm_campaign || '',
          gclid: params.gclid || ''
        });
        form.setAttribute('data-ml-qa-form-start-event', 'pushed');
      }, { passive: true });
    });

    window.dataLayer = window.dataLayer || [];
    var landingAlreadyPresent = window.dataLayer.some(function (item) {
      return item && item.event === 'landing_view' && item.page_path === window.location.pathname;
    });
    if (!landingAlreadyPresent) {
      pushEvent('landing_view', {
        selected_sku: document.body.getAttribute('data-ml-selected-sku') || '',
        utm_source: params.utm_source || '',
        utm_medium: params.utm_medium || '',
        utm_campaign: params.utm_campaign || '',
        utm_content: params.utm_content || '',
        utm_term: params.utm_term || '',
        gclid: params.gclid || '',
        first_landing_page: attribution.first && attribution.first.landing_page
      });
    }
    document.body.setAttribute('data-ml-qa-landing-view', landingAlreadyPresent ? 'existing' : 'pushed');

    var query = new URLSearchParams(window.location.search);
    document.body.setAttribute('data-ml-qa-consultation-request', 'armed');
    if (query.get('contact_posted') === 'true') {
      var conversionKey = 'ml_consultation_request:' + window.location.pathname;
      var consultationOnLayer = window.dataLayer.some(function (item) { return item && item.event === 'consultation_request'; });
      if (!readStore(conversionKey, true) && !consultationOnLayer) {
        safeStore(conversionKey, '1', true);
        pushEvent('consultation_request', {
          form_id: document.querySelector('form[data-ml-attribution-form]') ? '108-room-fit' : 'consultation',
          selected_sku: 'ML-LS-108-G125',
          utm_source: params.utm_source || '',
          utm_campaign: params.utm_campaign || '',
          gclid: params.gclid || '',
          project_type: query.get('project_type') || '',
          lead_priority: query.get('lead_priority') || '',
          lead_owner: query.get('lead_owner') || '',
          handoff_source: query.get('handoff_source') || '',
          handoff_id: query.get('handoff_id') || ''
        });
        document.body.setAttribute('data-ml-qa-consultation-request', 'pushed');
      } else {
        document.body.setAttribute('data-ml-qa-consultation-request', 'existing');
      }
    }

    window.MicroLuxAttribution = {
      version: '1.1.0-qa',
      get: function () { return safeParse(readStore(STORAGE_KEY)); },
      decorate: function () {
        document.querySelectorAll('a[href]').forEach(function (anchor) {
          decorateScheduleLink(anchor, captureAttribution());
        });
      },
      hydrate: function () {
        document.querySelectorAll('form[action*="/contact"], form[data-ml-attribution-form]').forEach(function (form) {
          hydrateForm(form, captureAttribution());
        });
      },
      event: pushEvent
    };
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (anchor) decorateScheduleLink(anchor, captureAttribution());
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


